/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Signal, effect } from '@angular/core';
import { Scenario } from '@scenario/models/scenario.model';
import { UnitRate } from '@scenario/models/unit-rate.model';
import { select } from '@store/injectables';
import { selectSelectedScenarios } from '@store/scenario/scenarios/selected-scenarios-slice';
import {
  selectSelectedNominalUnitRate,
  selectSelectedUnitRates,
} from '@store/scenario/unit-rates/selected-unit-rates-slice';
import { selectChartMarkersConfiguration, selectHistoricalDataMode } from '@store/scenario/app/app-slice';
import { Chart } from 'chart.js/auto';
import { InsightService } from '@app/services/insight.service';
import { PriceChartBuilder } from '@primaries/chartjs/price-chart.builder';
import { IconComponent } from '@totalenergiescode/tds-angular';
import { HistoricalDataMode } from '@scenario/enums/historical-data-mode.enum';
import { applyHistoricalDataMode } from '@scenario/models/historical-data-mode.utils';


@Component({
    selector: 'app-prices-chart',
    templateUrl: './prices-chart.component.html',
    styleUrl: './prices-chart.component.scss',
    imports: [IconComponent]
})
export class PricesChartComponent {
  public chart: Chart;
  private priceChartBuilder: PriceChartBuilder;
  selectedScenariosSignal: Signal<Scenario[]> = select(selectSelectedScenarios);
  selectedUnitRatesSignal: Signal<UnitRate> = select(selectSelectedUnitRates);
  selectedNominalUnitRateSignal: Signal<UnitRate> = select(selectSelectedNominalUnitRate);
  chartMarkersConfigurationViewModel = select(selectChartMarkersConfiguration);
  historicalDataModeSignal: Signal<HistoricalDataMode> = select(selectHistoricalDataMode);

  constructor(private readonly insightService: InsightService) {
    effect(() => {
      this.chart?.destroy();
      this.cleanHtmlLegend();
      const mode = this.historicalDataModeSignal();
      const scenarios = applyHistoricalDataMode(this.selectedScenariosSignal(), mode);
      if (scenarios.length > 0 && this.selectedUnitRatesSignal()) {
        this.priceChartBuilder = new PriceChartBuilder(
          scenarios,
          this.selectedUnitRatesSignal(),
          this.chartMarkersConfigurationViewModel(),
          this.insightService,
          this.selectedNominalUnitRateSignal(),
        );
        this.chart = this.priceChartBuilder.build();
      }
    });
  }

  cleanHtmlLegend() {
    const legendContainer = document.getElementById('legend-container');
    if (legendContainer) {
      legendContainer.innerHTML = '';
    }
  }
}
